
$(window).on('load',() => {
    (()=>{
      $(document).ready(() =>{
        $(document).on("swell:initialized",() => {
          console.log("swell initialized");
          
        });
  
        $(document).on("swell:setup",() => {
          console.log("swell setup");
       // new DashBoard(swellAPI.getCustomerDetails()).renderDarshbaord();
         let vipTiersOrder = swellAPI.getVipTiers().sort((a, b) => a.swellrequiredAmountSpentCents - b.swellrequiredAmountSpentCents);
        
          new VipTiers(
              vipTiersOrder,
              loyaltyConstants.vipTiers.currentStatusLabel,
              loyaltyConstants.vipTiers.benefitHeaders,
              loyaltyConstants.vipTiers.benefitHeadersTitle,
              loyaltyConstants.vipTiers.benefitsList,
              swellAPI.getCustomerDetails()
            ).renderVipTiers();

            new DashBoard(swellAPI.getCustomerDetails()).renderDarshbaord();
        });
      });
    }).call(this);
  })
  
  